'use es6';

import DisplayValueCurrencyCode from 'customer-data-filters/components/display/DisplayValueCurrencyCode';
import FilterOperatorCurrencyCodeInput from 'customer-data-filters/components/operator/FilterOperatorCurrencyCodeInput';
export default function makeCurrencyField() {
  const InputComponent = FilterOperatorCurrencyCodeInput;
  const ValueComponent = DisplayValueCurrencyCode;
  return {
    InputComponent,
    ValueComponent
  };
}